"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MalomoButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const config_1 = require("assets/styles/config");
const config_2 = require("assets/styles/config");
const computeMarginTop = (props) => {
    if (props.marginTopLarge) {
        return `margin-top: ${config_2.spacing.large};`;
    }
    return '';
};
const PrimaryButton = styled_components_1.default.button `
  align-items: center;
  background: ${config_1.colors.blurple};
  border: none;
  border-radius: 4px;
  color: ${config_1.colors.white};
  display: flex;
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  height: 40px;
  justify-content: center;
  width: auto;
  margin: ${(props) => props.margin && props.margin};
  padding: 1em;
  ${(props) => computeMarginTop(props)}

  &:hover, &:focus {
    background: ${config_1.colors.indigo};
    color: ${config_1.colors.white};
  }

  &:disabled {
    opacity: 50%;
    pointer-events: none;
  }

  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
`;
const SecondaryButton = (0, styled_components_1.default)(PrimaryButton) `
  background: ${config_1.colors.white};
  border: 1px solid ${config_1.colors.huron};
  color: ${config_1.colors.black};

  ${(props) => props.subtle
    ? (0, styled_components_1.css) `
          border-radius: 4px;
          border: 1px solid ${config_1.colors.huron};
          font-size: ${config_1.fontSizes.small};
        `
    : ''}

  &:hover, &:focus {
    border: 1px solid ${config_1.colors.indigo};
    background: ${config_1.colors.white};
    color: ${config_1.colors.black};
  }

  ${(props) => props.rounded && 'border-radius: 4px;'}
`;
const MalomoButton = (_a) => {
    var { secondary } = _a, rest = __rest(_a, ["secondary"]);
    if (secondary) {
        return react_1.default.createElement(SecondaryButton, Object.assign({}, rest));
    }
    return react_1.default.createElement(PrimaryButton, Object.assign({}, rest));
};
exports.MalomoButton = MalomoButton;
